/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable no-sparse-arrays */

import {
  dropDownFilterOptions,
  getFacilityIDSearchLookups,
  getFacilitySearchLookups,
} from '@AMIEWEB/GlobalSearch/helper';
import { getCitiesByKeyword } from 'app/services/SharedServices/SharedServices';

import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import i18next from 'i18next';
import { positionOpts } from '../../Helper/Types';

export enum FacilityFilterNames {
  fid = 'facilityIds',
  facility = 'facilityIds',
  facilityStatus = 'facilityStatusIds',
  division = 'divisionIds',
  state = 'states',
  city = 'city',
  accountManager = 'amUserIds',
  positions = 'positions',
}
export class FacilityFilterSpecs {
  constructor(public filterSpecs: any, public gridStateFilters: any) {}

  getFacilityFilterSpecs = () => [
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.facilityId'),
      name: FacilityFilterNames.fid,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      fetchOptions: getFacilityIDSearchLookups,
      isMultiSelect: true,
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.facilityName'),
      name: FacilityFilterNames.facility,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      fetchOptions: getFacilitySearchLookups,
      isMultiSelect: true,
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.facilityStatus'),
      name: FacilityFilterNames.facilityStatus,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: this.filterSpecs.facilityStatusesOpts,
      selectAllValue: 'All',
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.positions'),
      name: FacilityFilterNames.positions,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: positionOpts,
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.division'),
      name: FacilityFilterNames.division,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: this.filterSpecs.divisionOpts,
      selectAllValue: 'All',
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.city'),
      name: FacilityFilterNames.city,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      fetchOptions: async key => await getCitiesByKeyword(key),
      isMultiSelect: true,
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.state'),
      name: FacilityFilterNames.state,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: this.filterSpecs.statesOpts,
      selectAllValue: 'All',
      filterOptions: (options, { inputValue }) => {
        return dropDownFilterOptions(options, inputValue);
      },
    },
    {
      filterName: i18next.t('search.globalSearch.facility.filterNames.accountManager'),
      name: FacilityFilterNames.accountManager,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: this.filterSpecs.accountManagerOpts,
      selectAllValue: 'All',
    },
  ];
}
